<!--
@Author: MIYONGLE
@Desc: 职位详情  -- 衡阳慧用工做icp使用，页面废弃
@Date: 2021-04-16 18时
-->

<template>
  <div class="min-width-pc960">

    <!-- 标题 -->
    <div class="recruit-title">招聘详情</div>

    <!-- 内容 -->
    <div class="block-item">
      <span class="block-item-title">{{posiInfo.posiTitle}}</span>
      <span class="block-item-tip">{{posiInfo.experience}}</span>
      <div>
        <span>服务地点：{{posiInfo.serviceLoca}}</span>
        <span>工作周期：{{posiInfo.employmentCycle}}</span>
        <span>报名</span>
      </div>
    </div>

    <!-- 任务描述 -->
    <div class="block-item">
      <span class="block-item-title">任务描述</span>
      <span class="block-item-span">服务内容：{{posiInfo.serviceContent}}</span>
      <span class="block-item-span">服务时间：{{posiInfo.serviceTime}}</span>
      <span class="block-item-span">计费模式：{{posiInfo.billingMode}}</span>
      <span class="block-item-span">其他福利：无</span>
    </div>

    <!-- 报名 -->
    <span class='login-btn'>登录后即可报名</span>
  </div>
</template>

<script>
  import {POSILIST} from '../../service/businessConsts';
  import {getLocal} from "../../filters/filters";

  export default {
    name: "job-recruit-detail",
    data(){
      return {
        posiList: POSILIST,
        posiInfo: {}
      }
    },

    created(){
      this.posiInfo = getLocal('posiInfo') || '';
    },

    methods: {
      
    },
  }
</script>

<style lang="scss" scoped>
.recruit-title{
  font-size: 24px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #100F0F;
  line-height: 33px;
  text-align: left;
  &::before{
    width: 4px;
    height: 21px;
    background: #1985FF;
    border-radius: 3px;
    display: inline-block;
    content: ' ';
    margin-right: 9px;
  }
}

.min-width-pc960{
  width: 960px;
  margin: 0 auto;
  margin-top: 148px;
}

.block-item{
  width: 960px;
  background: #fff;
  padding: 32px;
  box-sizing: border-box;
  box-shadow: 0px 20px 60px -10px rgba(25, 133, 255, 0.1);
  margin-top: 32px;
  text-align: left;
  .block-item-title{
    font-size: 32px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #100F0F;
    margin-bottom: 24px;
    display: block;
  }
  .block-item-tip{
    background: rgba(25, 133, 255, 0.3);
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #1985FF;
    padding: 3px 15px;

  }
  div{
    border-top: 1px solid #F2F2F2;
    margin-top: 12px;
    span:nth-child(1){
      font-size: 16px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #666666;
      line-height: 22px;
      display: block;
      margin-top: 24px;
    }
    span:nth-child(2){
      font-size: 16px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #666666;
      line-height: 22px;
      display: block;
      margin-top: 12px;
    }
    span:nth-child(3){
      font-size: 16px;
      font-family: PingFangSC-Regular, PingFang SC;
      width: 148px;
      height: 48px;
      background: #1985FF;
      border-radius: 30px;
      display: block;
      font-size: 18px;
      font-family: MicrosoftYaHei;
      color: #FFFFFF;
      line-height: 48px;
      text-align: center;
      float: right;
      position: relative;
      bottom: 50px;
      cursor: pointer;
    }
  }
}

.block-item-span{
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #666666;
  line-height: 22px;
  display: block;
  margin-top: 12px;
}
.login-btn{
  width: 500px;
  height: 66px;
  background: #000000;
  border-radius: 4px;
  opacity: 0.5;
  display: block;
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #FFFFFF;
  margin: 30px auto;
  line-height: 66px;
  cursor: pointer;
  margin-bottom: 150px;
}
</style>


// WEBPACK FOOTER //
// src/views/pc/jobRecruitDetail.vue